// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * SB 574 Process Audit landing page.
 * Soft UI "page-header" hero (matches the homepage) + the one pager's
 * journey ladder, duty list and icon draw-in, in BuzBiz gold.
 */
.process-audit {
  --pa-ink: #141727;
  --pa-text: #344767;
  --pa-muted: #67748e;
  --pa-gold: #ffbc00;
  --pa-gold-deep: #e89a00;
  --pa-gold-text: #8a6500;
  --pa-insert: #1849a9;
  --pa-hairline: #e9ecef;
  --pa-tint: #f8f9fa;

  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  color: var(--pa-text);
  background: #fff;
}

/* ---------- Hero ---------- */
.pa-hero {
  position: relative;
  padding: 9rem 0 7rem;
  overflow: hidden;
  color: #fff;
  background: var(--pa-ink) center / cover no-repeat;
}

.pa-hero-mask {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);
  opacity: 0.88;
  pointer-events: none;
}

.pa-hero-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  align-items: center;
}

.pa-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  max-width: 100%;
  margin-bottom: 1.75rem;
  padding: 0.3rem 0.875rem 0.3rem 0.3rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #fff;
  border-radius: 2rem;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.18);
  -webkit-backdrop-filter: saturate(200%) blur(30px);
  backdrop-filter: saturate(200%) blur(30px);
  transition: background-color 0.2s ease;
  animation: fadeInDown 0.8s ease-out;
}

.pa-pill:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
}

.pa-pill-badge {
  flex-shrink: 0;
  padding: 0.2rem 0.6rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--pa-ink);
  border-radius: 2rem;
  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);
}

.pa-pill-arrow {
  transition: transform 0.2s ease;
}

.pa-pill:hover .pa-pill-arrow {
  transform: translateX(3px);
}

.pa-title {
  margin: 0 0 1.25rem;
  font-size: clamp(2.25rem, 5vw, 3.5rem);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.025em;
  color: #fff;
  animation: fadeInUp 0.8s ease-out 0.1s both;
}

.pa-gold {
  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, #ffd34d 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.pa-lead {
  max-width: 560px;
  margin: 0 0 2.25rem;
  font-size: 1.2rem;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.82);
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

.pa-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem 1.5rem;
  animation: fadeInUp 0.8s ease-out 0.3s both;
}

/* Soft UI buttons */
.process-audit .pa-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.95rem 1.9rem;
  font-size: 0.8125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  line-height: 1.4;
  white-space: nowrap;
  border-radius: 0.5rem;
  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);
  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in;
}

.process-audit .pa-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);
}

.process-audit .pa-btn-gold,
.process-audit .pa-btn-gold:hover {
  color: var(--pa-ink);
  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);
}

.pa-link {
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 4px;
  transition: text-decoration-color 0.2s ease;
}

.pa-link-light,
.pa-link-light:hover {
  color: #fff;
  text-decoration-color: rgba(255, 255, 255, 0.4);
}

.pa-link-light:hover {
  text-decoration-color: var(--pa-gold);
}

/* Glass card holding the journey ladder */
.pa-journey-card {
  padding: 1.75rem 1.75rem 2rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.16), 0 20px 27px 0 rgba(0, 0, 0, 0.12);
  -webkit-backdrop-filter: saturate(200%) blur(30px);
  backdrop-filter: saturate(200%) blur(30px);
  animation: fadeInUp 0.8s ease-out 0.35s both;
}

.pa-card-label {
  margin: 0 0 1.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.7);
}

.pa-curve {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 36px;
  overflow: hidden;
  z-index: 2;
  color: #fff;
}

.pa-curve svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: scale(2);
  transform-origin: top center;
}

/* ---------- Ladder (shared by journey + duties) ---------- */
.pa-ladder {
  --pa-line: var(--pa-ink);
  --pa-dot-bg: #fff;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pa-ladder li {
  position: relative;
  padding: 0 0 1.5rem 2.75rem;
}

.pa-ladder li:last-child {
  padding-bottom: 0;
}

.pa-ladder li:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 11.5px;
  top: 25px;
  bottom: -1px;
  width: 3px;
  border-radius: 2px;
  background: var(--pa-line);
  transform-origin: top;
}

.pa-dot {
  position: absolute;
  left: 0;
  top: -1px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1;
  color: var(--pa-ink);
  border: 2.5px solid var(--pa-line);
  border-radius: 50%;
  background: var(--pa-dot-bg);
}

.pa-ladder li.is-current .pa-dot {
  background: var(--pa-gold);
}

.pa-halo {
  position: absolute;
  left: -6px;
  top: -7px;
  width: 38px;
  height: 38px;
  border: 3px solid var(--pa-gold);
  border-radius: 50%;
  opacity: 0;
  pointer-events: none;
}

/* Journey ladder on the dark hero: draws in on load, no JS needed */
.pa-ladder-hero {
  --pa-line: rgba(255, 255, 255, 0.85);
  --pa-dot-bg: var(--pa-ink);
}

.pa-ladder-hero li.is-current .pa-dot {
  border-color: var(--pa-gold);
}

.pa-step-name {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #fff;
}

.pa-ladder-hero li.is-current .pa-step-name {
  font-size: 1.15rem;
}

.pa-here {
  padding: 0.125rem 0.5rem;
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--pa-ink);
  border-radius: 2rem;
  background: var(--pa-gold);
}

.pa-step-desc {
  margin-top: 0.125rem;
  font-size: 0.9375rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.66);
}

.pa-ladder-hero li.is-current .pa-step-desc {
  color: rgba(255, 255, 255, 0.92);
}

.pa-ladder-hero .pa-dot {
  animation: paFade 0.25s ease calc(var(--i) * 0.45s + 0.5s) both;
}

.pa-ladder-hero li::after {
  animation: paGrow 0.4s cubic-bezier(0.3, 0.6, 0.2, 1) calc(var(--i) * 0.45s + 0.6s) both;
}

.pa-ladder-hero .pa-halo {
  animation: paPulse 2.2s ease-out calc(var(--i) * 0.45s + 1.1s) infinite both;
}

/* ---------- Sections ---------- */
.pa-section {
  padding: 5rem 0;
}

.pa-section-tint {
  background: var(--pa-tint);
}

.pa-eyebrow {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--pa-gold-text);
}

.pa-h2 {
  margin: 0 0 1.5rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 500;
  line-height: 1.1;
  letter-spacing: -0.015em;
  color: var(--pa-ink);
}

.pa-section-lead {
  max-width: 680px;
  margin: -0.5rem 0 2.5rem;
  font-size: 1.125rem;
  line-height: 1.65;
  color: var(--pa-text);
}

/* How the audit works */
.pa-steps {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
}

.pa-step {
  display: flex;
  gap: 1.25rem;
  padding: 1.75rem;
  background: #fff;
  border: 1px solid var(--pa-hairline);
  border-radius: 1rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pa-step:hover {
  transform: translateY(-3px);
  box-shadow: 0 24px 32px -4px rgba(0, 0, 0, 0.09);
}

.pa-step-icon {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  color: var(--pa-ink);
  border-radius: 0.75rem;
  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);
  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11);
}

.pa-step-word {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin: 0 0 0.375rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--pa-ink);
}

.pa-step-num {
  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--pa-muted);
  font-variant-numeric: tabular-nums;
}

.pa-step p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
}

/* What we check against */
.pa-check-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.pa-card {
  padding: 2rem 1.75rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.pa-duties li {
  padding-bottom: 1.375rem;
}

.pa-duty-label {
  font-size: 1rem;
  line-height: 1.5;
  color: var(--pa-ink);
}

.pa-duties li.is-current .pa-duty-label {
  font-weight: 600;
}

.pa-duty-code,
.pa-code {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.4;
  color: var(--pa-muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.pa-duty-code {
  margin-top: 0.125rem;
}

.pa-check-side {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.pa-example {
  padding: 1.5rem 1.5rem 1.5rem 1.375rem;
  background: #fff;
  border-left: 4px solid var(--pa-gold);
  border-radius: 0 1rem 1rem 0;
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.pa-example-tag {
  display: inline-block;
  margin-bottom: 0.625rem;
  padding: 0.2rem 0.6rem;
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--pa-ink);
  border-radius: 0.375rem;
  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);
}

.pa-example h3 {
  margin: 0 0 0.375rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--pa-ink);
}

.pa-example p {
  margin: 0;
  line-height: 1.6;
}

.pa-example .pa-muted {
  margin-top: 0.375rem;
  font-size: 0.9375rem;
  color: var(--pa-muted);
}

.pa-banner {
  padding: 1rem 1.25rem;
  font-size: 0.9375rem;
  line-height: 1.5;
  border-left: 4px solid var(--pa-ink);
  border-radius: 0 1rem 1rem 0;
  background: #eef0f3;
}

.pa-banner b {
  display: block;
  font-weight: 600;
  color: var(--pa-ink);
}

.pa-banner span {
  color: var(--pa-muted);
}

/* Outcome + CTA */
.pa-outcome {
  max-width: 820px;
  margin: 0 0 3rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: clamp(1.75rem, 3.6vw, 2.5rem);
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: var(--pa-ink);
}

.pa-cta-card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: center;
  padding: 2.25rem 2rem;
  color: #fff;
  border-radius: 1rem;
  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.12);
}

.pa-cta-title {
  margin: 0 0 0.5rem;
  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;
  font-size: clamp(1.6rem, 3vw, 2rem);
  font-weight: 500;
  line-height: 1.15;
  color: #fff;
}

.pa-cta-copy p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.78);
}

.pa-contact {
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 1.5rem;
  padding-top: 1.25rem;
  font-size: 0.9375rem;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
}

.pa-contact b {
  padding: 0.375rem 0;
  font-weight: 600;
  color: #fff;
}

.pa-contact a {
  padding: 0.375rem 0;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: underline;
  text-decoration-color: rgba(255, 255, 255, 0.3);
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
}

.pa-contact a:hover {
  color: #fff;
  text-decoration-color: var(--pa-gold);
}

.pa-disclaimer {
  margin: 1rem 0 0;
  font-size: 0.75rem;
  color: var(--pa-muted);
}

.process-audit a:focus-visible {
  outline: 2px solid var(--pa-gold);
  outline-offset: 3px;
}

/* ---------- Reveal on scroll (only once JS sets .pa-anim) ---------- */
.pa-anim .pa-steps .pa-step-icon path,
.pa-anim .pa-steps .pa-step-icon rect {
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
}

.pa-anim .pa-steps.pa-go .pa-step-icon path,
.pa-anim .pa-steps.pa-go .pa-step-icon rect {
  stroke-dashoffset: 0;
  transition: stroke-dashoffset 0.8s cubic-bezier(0.3, 0.6, 0.2, 1) calc(var(--i) * 0.25s + 0.2s);
}

.pa-anim .pa-steps .pa-step {
  opacity: 0;
  transform: translateY(12px);
}

.pa-anim .pa-steps.pa-go .pa-step {
  opacity: 1;
  transform: none;
  transition: opacity 0.5s ease calc(var(--i) * 0.15s), transform 0.5s ease calc(var(--i) * 0.15s),
    box-shadow 0.2s ease;
}

.pa-anim .pa-steps.pa-go .pa-step:hover {
  transform: translateY(-3px);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pa-anim .pa-duties li::after {
  transform: scaleY(0);
}

.pa-anim .pa-duties .pa-dot {
  opacity: 0;
}

.pa-anim .pa-duties.pa-go li::after {
  transform: scaleY(1);
  transition: transform 0.4s cubic-bezier(0.3, 0.6, 0.2, 1) calc(var(--i) * 0.35s + 0.1s);
}

.pa-anim .pa-duties.pa-go .pa-dot {
  opacity: 1;
  transition: opacity 0.25s ease calc(var(--i) * 0.35s);
}

.pa-duties.pa-go .pa-halo {
  animation: paPulse 2.2s ease-out calc(var(--i) * 0.35s + 0.5s) infinite both;
}

@keyframes paFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes paGrow {
  from { transform: scaleY(0); }
  to { transform: scaleY(1); }
}

@keyframes paPulse {
  0% { transform: scale(0.7); opacity: 0; }
  15% { opacity: 0.9; }
  70%, 100% { transform: scale(1.35); opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .pa-pill,
  .pa-title,
  .pa-lead,
  .pa-actions,
  .pa-journey-card,
  .pa-ladder-hero .pa-dot,
  .pa-ladder-hero li::after,
  .pa-ladder .pa-halo {
    animation: none;
  }

  .process-audit .pa-btn,
  .process-audit .pa-btn:hover,
  .pa-step,
  .pa-step:hover {
    transform: none;
    transition: none;
  }
}

/* ---------- Layout ---------- */
@media (min-width: 768px) {
  .pa-steps {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .pa-step {
    flex-direction: column;
  }

  .pa-cta-card {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 2rem;
    padding: 2.75rem 3rem;
  }
}

@media (min-width: 980px) {
  .pa-hero {
    padding: 10rem 0 8rem;
  }

  .pa-hero-grid {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    gap: 4rem;
  }

  .pa-check-grid {
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
    gap: 2rem;
    align-items: start;
  }

  .pa-card {
    padding: 2.5rem 2.25rem;
  }
}

@media (max-width: 768px) {
  .pa-hero {
    padding: 7rem 0 5rem;
  }

  .pa-lead {
    font-size: 1.05rem;
  }

  .pa-actions .pa-btn,
  .pa-btn-wide {
    width: 100%;
  }

  .pa-journey-card {
    padding: 1.5rem 1.25rem 1.75rem;
  }

  .pa-section {
    padding: 3.5rem 0;
  }

  .pa-cta-card {
    padding: 1.75rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/process-audit/ProcessAuditPage.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;;EAElB,sEAAsE;EACtE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mEAAmE;EACnE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,uDAAuD;EACvD,kDAAkD;EAClD,0CAA0C;EAC1C,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,sFAAsF;AACxF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,+EAA+E;EAC/E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kFAAkF;EAClF,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;EACtB,mFAAmF;AACrF;;AAEA;;EAEE,oBAAoB;EACpB,sFAAsF;AACxF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qCAAqC;EACrC,0FAA0F;EAC1F,kDAAkD;EAClD,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA,oEAAoE;AACpE;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0DAA0D;EAC1D,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,sFAAsF;EACtF,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,0DAA0D;EAC1D,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sFAAsF;AACxF;;AAEA;EACE,oBAAoB;EACpB,0DAA0D;EAC1D,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;EAC1D,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,mEAAmE;EACnE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,0DAA0D;EAC1D,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,+CAA+C;EAC/C,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,+FAA+F;AACjG;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,uFAAuF;AACzF;;AAEA;EACE,UAAU;EACV,qDAAqD;AACvD;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA;EACE,KAAK,qBAAqB,EAAE,UAAU,EAAE;EACxC,MAAM,YAAY,EAAE;EACpB,YAAY,sBAAsB,EAAE,UAAU,EAAE;AAClD;;AAEA;EACE;;;;;;;;IAQE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0CAA0C;IAC1C,SAAS;IACT,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,uDAAuD;IACvD,SAAS;EACX;;EAEA;IACE,sDAAsD;IACtD,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/*\n * SB 574 Process Audit landing page.\n * Soft UI \"page-header\" hero (matches the homepage) + the one pager's\n * journey ladder, duty list and icon draw-in, in BuzBiz gold.\n */\n.process-audit {\n  --pa-ink: #141727;\n  --pa-text: #344767;\n  --pa-muted: #67748e;\n  --pa-gold: #ffbc00;\n  --pa-gold-deep: #e89a00;\n  --pa-gold-text: #8a6500;\n  --pa-insert: #1849a9;\n  --pa-hairline: #e9ecef;\n  --pa-tint: #f8f9fa;\n\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  color: var(--pa-text);\n  background: #fff;\n}\n\n/* ---------- Hero ---------- */\n.pa-hero {\n  position: relative;\n  padding: 9rem 0 7rem;\n  overflow: hidden;\n  color: #fff;\n  background: var(--pa-ink) center / cover no-repeat;\n}\n\n.pa-hero-mask {\n  position: absolute;\n  inset: 0;\n  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);\n  opacity: 0.88;\n  pointer-events: none;\n}\n\n.pa-hero-grid {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.pa-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.625rem;\n  max-width: 100%;\n  margin-bottom: 1.75rem;\n  padding: 0.3rem 0.875rem 0.3rem 0.3rem;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #fff;\n  border-radius: 2rem;\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.18);\n  -webkit-backdrop-filter: saturate(200%) blur(30px);\n  backdrop-filter: saturate(200%) blur(30px);\n  transition: background-color 0.2s ease;\n  animation: fadeInDown 0.8s ease-out;\n}\n\n.pa-pill:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.pa-pill-badge {\n  flex-shrink: 0;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: var(--pa-ink);\n  border-radius: 2rem;\n  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);\n}\n\n.pa-pill-arrow {\n  transition: transform 0.2s ease;\n}\n\n.pa-pill:hover .pa-pill-arrow {\n  transform: translateX(3px);\n}\n\n.pa-title {\n  margin: 0 0 1.25rem;\n  font-size: clamp(2.25rem, 5vw, 3.5rem);\n  font-weight: 700;\n  line-height: 1.1;\n  letter-spacing: -0.025em;\n  color: #fff;\n  animation: fadeInUp 0.8s ease-out 0.1s both;\n}\n\n.pa-gold {\n  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, #ffd34d 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.pa-lead {\n  max-width: 560px;\n  margin: 0 0 2.25rem;\n  font-size: 1.2rem;\n  line-height: 1.65;\n  color: rgba(255, 255, 255, 0.82);\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n.pa-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 1rem 1.5rem;\n  animation: fadeInUp 0.8s ease-out 0.3s both;\n}\n\n/* Soft UI buttons */\n.process-audit .pa-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.95rem 1.9rem;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  line-height: 1.4;\n  white-space: nowrap;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);\n  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in;\n}\n\n.process-audit .pa-btn:hover {\n  transform: scale(1.02);\n  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);\n}\n\n.process-audit .pa-btn-gold,\n.process-audit .pa-btn-gold:hover {\n  color: var(--pa-ink);\n  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);\n}\n\n.pa-link {\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n  transition: text-decoration-color 0.2s ease;\n}\n\n.pa-link-light,\n.pa-link-light:hover {\n  color: #fff;\n  text-decoration-color: rgba(255, 255, 255, 0.4);\n}\n\n.pa-link-light:hover {\n  text-decoration-color: var(--pa-gold);\n}\n\n/* Glass card holding the journey ladder */\n.pa-journey-card {\n  padding: 1.75rem 1.75rem 2rem;\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: inset 0 0 1px 1px rgba(255, 255, 255, 0.16), 0 20px 27px 0 rgba(0, 0, 0, 0.12);\n  -webkit-backdrop-filter: saturate(200%) blur(30px);\n  backdrop-filter: saturate(200%) blur(30px);\n  animation: fadeInUp 0.8s ease-out 0.35s both;\n}\n\n.pa-card-label {\n  margin: 0 0 1.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.pa-curve {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 36px;\n  overflow: hidden;\n  z-index: 2;\n  color: #fff;\n}\n\n.pa-curve svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(2);\n  transform-origin: top center;\n}\n\n/* ---------- Ladder (shared by journey + duties) ---------- */\n.pa-ladder {\n  --pa-line: var(--pa-ink);\n  --pa-dot-bg: #fff;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pa-ladder li {\n  position: relative;\n  padding: 0 0 1.5rem 2.75rem;\n}\n\n.pa-ladder li:last-child {\n  padding-bottom: 0;\n}\n\n.pa-ladder li:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  left: 11.5px;\n  top: 25px;\n  bottom: -1px;\n  width: 3px;\n  border-radius: 2px;\n  background: var(--pa-line);\n  transform-origin: top;\n}\n\n.pa-dot {\n  position: absolute;\n  left: 0;\n  top: -1px;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1;\n  color: var(--pa-ink);\n  border: 2.5px solid var(--pa-line);\n  border-radius: 50%;\n  background: var(--pa-dot-bg);\n}\n\n.pa-ladder li.is-current .pa-dot {\n  background: var(--pa-gold);\n}\n\n.pa-halo {\n  position: absolute;\n  left: -6px;\n  top: -7px;\n  width: 38px;\n  height: 38px;\n  border: 3px solid var(--pa-gold);\n  border-radius: 50%;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Journey ladder on the dark hero: draws in on load, no JS needed */\n.pa-ladder-hero {\n  --pa-line: rgba(255, 255, 255, 0.85);\n  --pa-dot-bg: var(--pa-ink);\n}\n\n.pa-ladder-hero li.is-current .pa-dot {\n  border-color: var(--pa-gold);\n}\n\n.pa-step-name {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n  color: #fff;\n}\n\n.pa-ladder-hero li.is-current .pa-step-name {\n  font-size: 1.15rem;\n}\n\n.pa-here {\n  padding: 0.125rem 0.5rem;\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--pa-ink);\n  border-radius: 2rem;\n  background: var(--pa-gold);\n}\n\n.pa-step-desc {\n  margin-top: 0.125rem;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.66);\n}\n\n.pa-ladder-hero li.is-current .pa-step-desc {\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.pa-ladder-hero .pa-dot {\n  animation: paFade 0.25s ease calc(var(--i) * 0.45s + 0.5s) both;\n}\n\n.pa-ladder-hero li::after {\n  animation: paGrow 0.4s cubic-bezier(0.3, 0.6, 0.2, 1) calc(var(--i) * 0.45s + 0.6s) both;\n}\n\n.pa-ladder-hero .pa-halo {\n  animation: paPulse 2.2s ease-out calc(var(--i) * 0.45s + 1.1s) infinite both;\n}\n\n/* ---------- Sections ---------- */\n.pa-section {\n  padding: 5rem 0;\n}\n\n.pa-section-tint {\n  background: var(--pa-tint);\n}\n\n.pa-eyebrow {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--pa-gold-text);\n}\n\n.pa-h2 {\n  margin: 0 0 1.5rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: clamp(2rem, 4vw, 2.75rem);\n  font-weight: 500;\n  line-height: 1.1;\n  letter-spacing: -0.015em;\n  color: var(--pa-ink);\n}\n\n.pa-section-lead {\n  max-width: 680px;\n  margin: -0.5rem 0 2.5rem;\n  font-size: 1.125rem;\n  line-height: 1.65;\n  color: var(--pa-text);\n}\n\n/* How the audit works */\n.pa-steps {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.25rem;\n}\n\n.pa-step {\n  display: flex;\n  gap: 1.25rem;\n  padding: 1.75rem;\n  background: #fff;\n  border: 1px solid var(--pa-hairline);\n  border-radius: 1rem;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.pa-step:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 24px 32px -4px rgba(0, 0, 0, 0.09);\n}\n\n.pa-step-icon {\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  color: var(--pa-ink);\n  border-radius: 0.75rem;\n  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);\n  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11);\n}\n\n.pa-step-word {\n  display: flex;\n  align-items: baseline;\n  gap: 0.5rem;\n  margin: 0 0 0.375rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--pa-ink);\n}\n\n.pa-step-num {\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--pa-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.pa-step p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n/* What we check against */\n.pa-check-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n}\n\n.pa-card {\n  padding: 2rem 1.75rem;\n  background: #fff;\n  border-radius: 1rem;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n}\n\n.pa-duties li {\n  padding-bottom: 1.375rem;\n}\n\n.pa-duty-label {\n  font-size: 1rem;\n  line-height: 1.5;\n  color: var(--pa-ink);\n}\n\n.pa-duties li.is-current .pa-duty-label {\n  font-weight: 600;\n}\n\n.pa-duty-code,\n.pa-code {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--pa-muted);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.pa-duty-code {\n  margin-top: 0.125rem;\n}\n\n.pa-check-side {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.pa-example {\n  padding: 1.5rem 1.5rem 1.5rem 1.375rem;\n  background: #fff;\n  border-left: 4px solid var(--pa-gold);\n  border-radius: 0 1rem 1rem 0;\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n}\n\n.pa-example-tag {\n  display: inline-block;\n  margin-bottom: 0.625rem;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--pa-ink);\n  border-radius: 0.375rem;\n  background-image: linear-gradient(310deg, var(--pa-gold-deep) 0%, var(--pa-gold) 100%);\n}\n\n.pa-example h3 {\n  margin: 0 0 0.375rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: var(--pa-ink);\n}\n\n.pa-example p {\n  margin: 0;\n  line-height: 1.6;\n}\n\n.pa-example .pa-muted {\n  margin-top: 0.375rem;\n  font-size: 0.9375rem;\n  color: var(--pa-muted);\n}\n\n.pa-banner {\n  padding: 1rem 1.25rem;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  border-left: 4px solid var(--pa-ink);\n  border-radius: 0 1rem 1rem 0;\n  background: #eef0f3;\n}\n\n.pa-banner b {\n  display: block;\n  font-weight: 600;\n  color: var(--pa-ink);\n}\n\n.pa-banner span {\n  color: var(--pa-muted);\n}\n\n/* Outcome + CTA */\n.pa-outcome {\n  max-width: 820px;\n  margin: 0 0 3rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: clamp(1.75rem, 3.6vw, 2.5rem);\n  font-weight: 500;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n  color: var(--pa-ink);\n}\n\n.pa-cta-card {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5rem;\n  align-items: center;\n  padding: 2.25rem 2rem;\n  color: #fff;\n  border-radius: 1rem;\n  background-image: linear-gradient(310deg, #141727 0%, #3a416f 100%);\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.12);\n}\n\n.pa-cta-title {\n  margin: 0 0 0.5rem;\n  font-family: 'Spectral', 'Iowan Old Style', Georgia, serif;\n  font-size: clamp(1.6rem, 3vw, 2rem);\n  font-weight: 500;\n  line-height: 1.15;\n  color: #fff;\n}\n\n.pa-cta-copy p {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.pa-contact {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem 1.5rem;\n  padding-top: 1.25rem;\n  font-size: 0.9375rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.14);\n}\n\n.pa-contact b {\n  padding: 0.375rem 0;\n  font-weight: 600;\n  color: #fff;\n}\n\n.pa-contact a {\n  padding: 0.375rem 0;\n  color: rgba(255, 255, 255, 0.85);\n  text-decoration: underline;\n  text-decoration-color: rgba(255, 255, 255, 0.3);\n  text-decoration-thickness: 2px;\n  text-underline-offset: 4px;\n}\n\n.pa-contact a:hover {\n  color: #fff;\n  text-decoration-color: var(--pa-gold);\n}\n\n.pa-disclaimer {\n  margin: 1rem 0 0;\n  font-size: 0.75rem;\n  color: var(--pa-muted);\n}\n\n.process-audit a:focus-visible {\n  outline: 2px solid var(--pa-gold);\n  outline-offset: 3px;\n}\n\n/* ---------- Reveal on scroll (only once JS sets .pa-anim) ---------- */\n.pa-anim .pa-steps .pa-step-icon path,\n.pa-anim .pa-steps .pa-step-icon rect {\n  stroke-dasharray: 1;\n  stroke-dashoffset: 1;\n}\n\n.pa-anim .pa-steps.pa-go .pa-step-icon path,\n.pa-anim .pa-steps.pa-go .pa-step-icon rect {\n  stroke-dashoffset: 0;\n  transition: stroke-dashoffset 0.8s cubic-bezier(0.3, 0.6, 0.2, 1) calc(var(--i) * 0.25s + 0.2s);\n}\n\n.pa-anim .pa-steps .pa-step {\n  opacity: 0;\n  transform: translateY(12px);\n}\n\n.pa-anim .pa-steps.pa-go .pa-step {\n  opacity: 1;\n  transform: none;\n  transition: opacity 0.5s ease calc(var(--i) * 0.15s), transform 0.5s ease calc(var(--i) * 0.15s),\n    box-shadow 0.2s ease;\n}\n\n.pa-anim .pa-steps.pa-go .pa-step:hover {\n  transform: translateY(-3px);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.pa-anim .pa-duties li::after {\n  transform: scaleY(0);\n}\n\n.pa-anim .pa-duties .pa-dot {\n  opacity: 0;\n}\n\n.pa-anim .pa-duties.pa-go li::after {\n  transform: scaleY(1);\n  transition: transform 0.4s cubic-bezier(0.3, 0.6, 0.2, 1) calc(var(--i) * 0.35s + 0.1s);\n}\n\n.pa-anim .pa-duties.pa-go .pa-dot {\n  opacity: 1;\n  transition: opacity 0.25s ease calc(var(--i) * 0.35s);\n}\n\n.pa-duties.pa-go .pa-halo {\n  animation: paPulse 2.2s ease-out calc(var(--i) * 0.35s + 0.5s) infinite both;\n}\n\n@keyframes paFade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes paGrow {\n  from { transform: scaleY(0); }\n  to { transform: scaleY(1); }\n}\n\n@keyframes paPulse {\n  0% { transform: scale(0.7); opacity: 0; }\n  15% { opacity: 0.9; }\n  70%, 100% { transform: scale(1.35); opacity: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pa-pill,\n  .pa-title,\n  .pa-lead,\n  .pa-actions,\n  .pa-journey-card,\n  .pa-ladder-hero .pa-dot,\n  .pa-ladder-hero li::after,\n  .pa-ladder .pa-halo {\n    animation: none;\n  }\n\n  .process-audit .pa-btn,\n  .process-audit .pa-btn:hover,\n  .pa-step,\n  .pa-step:hover {\n    transform: none;\n    transition: none;\n  }\n}\n\n/* ---------- Layout ---------- */\n@media (min-width: 768px) {\n  .pa-steps {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .pa-step {\n    flex-direction: column;\n  }\n\n  .pa-cta-card {\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 2rem;\n    padding: 2.75rem 3rem;\n  }\n}\n\n@media (min-width: 980px) {\n  .pa-hero {\n    padding: 10rem 0 8rem;\n  }\n\n  .pa-hero-grid {\n    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);\n    gap: 4rem;\n  }\n\n  .pa-check-grid {\n    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);\n    gap: 2rem;\n    align-items: start;\n  }\n\n  .pa-card {\n    padding: 2.5rem 2.25rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .pa-hero {\n    padding: 7rem 0 5rem;\n  }\n\n  .pa-lead {\n    font-size: 1.05rem;\n  }\n\n  .pa-actions .pa-btn,\n  .pa-btn-wide {\n    width: 100%;\n  }\n\n  .pa-journey-card {\n    padding: 1.5rem 1.25rem 1.75rem;\n  }\n\n  .pa-section {\n    padding: 3.5rem 0;\n  }\n\n  .pa-cta-card {\n    padding: 1.75rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
